<template>
  <header>
    <h1 class="animate__animated animate__fadeInDown">HELLO</h1>
    <img class="img-wgs" src="../../assets/main/first-1.jpg">
  </header>
  <main>
    <p>这 只 是 一 个 比 较 神 奇 的 网 站 。</p>
    <p>或 许 简 陋 。</p>
    <p>不 过 不 要 着 急 划 走 。</p>
    <p>留 下 来 转 一 转 也 许 会 有 惊 喜 。</p>
  </main>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "first",
  props: {
    isShow: {},
  },
}
</script>

<style scoped>
.img-wgs {
  width: 100%;

}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding-top: 61.93333333%;
  background-size: cover;
  font-family: 'Sucrose Bold Two';
  position: absolute;
  top: 0;
  right: 0;
  width: 45.8%;
}

header h1 {
  position: fixed;
  top: 5rem;
  right: 2rem;
  font-size: 12vw;
  line-height: .8;
  margin-top: 0;
  text-align: center;
}

header h1 span {
  display: block;
  font-size: 8.75vw;
}

main {
  background: #fff;
  position: relative;
  border: 1px solid #fff;
  font-family: 'IM Fell French Canon Pro';
  font-size: 1.4rem;
  padding: 2rem 25%;
  line-height: 1.6;
}

@media all and (max-width: 400px) {
  main {
    padding: 2rem;
  }
}
</style>